<div class="row">
  <div class="col-12">
    <div class="file-handling-wrapper">
      <div class="box-small">
        <div class="file-handling-label">
          1. {{ 'i18n.domain.import-protocol.file-handling.existing-files' | translate}}
        </div>
        @if (hasOriginalFile) {
          <a href="#" (click)="downloadOriginalFile()">{{ 'i18n.domain.import-protocol.file-handling.original-file' | translate}}</a>
        }
        @if (hasOriginalArchiveFile) {
          <a href="{{originalArchiveFileUrl}}">{{ 'i18n.domain.import-protocol.file-handling.original-archive-file' | translate}}</a>
        }
        @if (hasImportFile) {
          <a href="#" (click)="downloadImportFile()">{{ 'i18n.domain.import-protocol.file-handling.import-file' | translate}}</a>
        }
        @if (hasFixedImportFile) {
          <a href="#" (click)="downloadFixedImportFile()">{{ 'i18n.domain.import-protocol.file-handling.fixed-import-file' | translate}}</a>
        }
      </div>
      <div class="box-wide">
        <div class="file-handling-label">
          2. {{ 'i18n.domain.import-protocol.file-handling.upload-file' | translate}}
        </div>
        <div #dropArea class="uploader">
          <ejs-uploader #defaultupload
                        [allowedExtensions]="allowedExtensions"
                        multiple="false"
                        [autoUpload]="false"
                        (removing)="onFileRemove()"
                        (selected)="handleFileInput($event)"
                        [dropArea]='dropArea'
                        [enabled]="canUploadFile">
          </ejs-uploader>
        </div>
      </div>
      <div class="box-small">
        <div class="file-handling-label">
          3. {{ 'i18n.domain.import-protocol.file-handling.newly-import' | translate}}
        </div>
        <button class="btn btn-outline-secondary import-btn" [disabled]="!canImport" (click)="onImport()">{{'i18n.domain.import-protocol.file-handling.import' | translate}}</button>
      </div>
    </div>
  </div>
</div>
